export { NileSideBarGroupItemIcon } from './nile-side-bar-group-item-icon';